export const STALE_THRESHOLD_MS = 60 * 60 * 1000

export type GpsIssuesInput = {
  isGpsConfigured: boolean
  lastReceivedAt: number | undefined
  now: number
}

export type GpsIssues = {
  gpsNotConfigured: boolean
  gpsNeverReceived: boolean
  gpsStale: boolean
}

export const computeGpsIssues = (input: GpsIssuesInput): GpsIssues => {
  const { isGpsConfigured, lastReceivedAt, now } = input

  const gpsNotConfigured = !isGpsConfigured
  const gpsNeverReceived = isGpsConfigured && lastReceivedAt === undefined
  const gpsStale =
    isGpsConfigured &&
    lastReceivedAt !== undefined &&
    now - lastReceivedAt > STALE_THRESHOLD_MS

  return { gpsNotConfigured, gpsNeverReceived, gpsStale }
}
